module.exports = {"BASE_URL":"sysUser","api":[{"name":"login","method":"POST","desc":"登录接口","path":"/login","params":{"loginName":"admin","password":"admin"}},{"name":"logout","method":"POST","desc":"注销","mock":false,"path":"/logout","params":{}},{"name":"getCurrentUser","method":"GET","desc":"获取用户信息","mock":false,"path":"/","params":{}},{"name":"needVCode","method":"GET","desc":"是否需要验证码","mock":false,"append":true,"path":"/isNeedVerificatCode","params":{}},{"name":"updateUserPassword","method":"POST","desc":"修改密码","mock":false,"path":"/updateUserPassWord","params":{}}]}


//////////////////
// WEBPACK FOOTER
// ./src/api/apis/base.json
// module id = B6rY
// module chunks = 249